import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/productlist/FilterM";

interface Props {
	tagList: string[];
	handleTagCheck: (checked: boolean, value: string) => void;
	dataStr: string;
}

const DepartureTimeComponent = ({tagList, handleTagCheck, dataStr}: Props) => {
	const dataList = dataStr.replaceAll("|", "").split("^");

	return (
		<style.CheckList>
			<style.CheckListItem>
				<input
					type="checkbox"
					id="outDeprtFgList0"
					onChange={e => handleTagCheck(e.target.checked, e.target.value)}
					checked={!tagList.length}
					value={"전체"}
				/>
				<label htmlFor="outDeprtFgList0">
					<span>전체</span>
				</label>
			</style.CheckListItem>
			{dataList.map((value, idx) => (
				<style.CheckListItem key={idx}>
					<input
						type="checkbox"
						id={`outDeprtFgList${idx + 1}`}
						onChange={e => handleTagCheck(e.target.checked, e.target.value)}
						checked={tagList.includes(value)}
						value={value}
					/>
					<label htmlFor={`outDeprtFgList${idx + 1}`}>
						<span>{value}</span>
					</label>
				</style.CheckListItem>
			))}
		</style.CheckList>
	);
};

const DepartureTime = (props: Props) => (
	<ErrorBoundary logMsg="DetailFilter DepartureTime Error">
		<DepartureTimeComponent {...props} />
	</ErrorBoundary>
);

export default DepartureTime;
